import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})
export class AuthService { 
// --port 42001 --proxy-config proxy.conf.json
  //url: any = 'http://192.168.1.72:8180';  
  //url: any = 'http://69.175.49.82:3004';  
  url: any = 'https://hoshinup.garocedev.com:3004';  

  constructor(
    private http: HttpClient
  ) { }
  

 
  calndar(date,calendar_,descripcion){
    var service="http://localhost/api/api.calendar.php";
    var url_=service+"?token=123456789&date_start="+date+"&date_end="+date+"&descripcion="+descripcion+"&calendar="+calendar_;
    let seq = this.http.get<any>(url_).map((res) => res).toPromise();
    return seq;
  }
  service(method_,postData){
    let seq = this.http.post<any>(this.url +method_, postData).map((res) => res).toPromise();
    return seq;
  }


}
